<template>
    <v-app>
        <component :is="layout">
            <router-view></router-view>
            <alert></alert>
        </component>
    </v-app>
</template>

<script>
    import {localize} from 'vee-validate'
    import Alert from "./components/Alert";
    export default {
        name: 'App',
        components: {Alert},
        computed: {
            layout() {
                return (this.$route.meta.layout || 'default') + '-layout';
            }
        },
        mounted() {
            console.log(`%c ${process.env.VUE_APP_NAME}`, 'color: green; font-weight: bold; font-size: 40px; text-shadow: 2px 2px #0A5222');
        }
    };
</script>
